var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88867 16V39.3333C3.88867 40.571 4.3833 41.758 5.26376 42.6332C6.14421 43.5083 7.33836 44 8.58351 44H41.4474C42.6925 44 43.8867 43.5083 44.7671 42.6332C45.6476 41.758 46.1422 40.571 46.1422 39.3333V16",
    stroke: "#F79C00",
    strokeWidth: 3.46918
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9334 2H35.5625L36.7362 13.6667C36.7362 13.6667 39.0836 16 42.6048 16C44.4531 16.0024 46.2387 15.3336 47.6259 14.1193C47.7725 13.9831 47.8818 13.812 47.9434 13.6222C48.005 13.4323 48.0169 13.23 47.978 13.0343L46.3207 3.16667C46.2653 2.84069 46.0956 2.54472 45.8417 2.33119C45.5877 2.11766 45.266 2.00034 44.9334 2Z",
    stroke: "#F79C00",
    strokeWidth: 3.46918
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5614 2L36.7351 13.6667C36.7351 13.6667 34.3877 16 30.8666 16C27.3455 16 24.998 13.6667 24.998 13.6667V2H35.5614Z",
    stroke: "#F79C00",
    strokeWidth: 3.46918
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9988 2V13.6667C24.9988 13.6667 22.6514 16 19.1303 16C15.6091 16 13.2617 13.6667 13.2617 13.6667L14.4354 2H24.9988Z",
    stroke: "#F79C00",
    strokeWidth: 3.46918
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4353 2H5.0668C4.73345 1.99988 4.41086 2.11728 4.15641 2.33133C3.90196 2.54538 3.73213 2.8422 3.67712 3.169L2.02219 13.0367C1.98351 13.2324 1.99554 13.4346 2.05713 13.6244C2.11873 13.8142 2.22787 13.9853 2.37431 14.1217C3.14426 14.7983 4.86492 16.0023 7.39309 16.0023C10.9142 16.0023 13.2616 13.669 13.2616 13.669L14.4353 2Z",
    stroke: "#F79C00",
    strokeWidth: 3.46918
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceIcon);
export default __webpack_public_path__ + "static/media/marketplace-icon.2f8a46fab1bd070730e9408599195327.svg";
export { ForwardRef as ReactComponent };